import React, { useEffect, useRef, useState } from 'react'
import "./blogPage.css"
import BlogCard from './BlogCard'
import LoadingCircle from '../loading_circle/LoadingCircle';

export default function BlogPage(props) {
  const post_per_page = 10;
  const [blogsToShow, setBlogsToShow] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const setLoadingBarProgress = useRef(null);
  
  useEffect(()=>{
    if (!setLoadingBarProgress.current) {
      setLoadingBarProgress.current = props.setLoadingBarProgress ?? null;
    }
  }, [props]);

  useEffect(()=>{
    document.getElementsByClassName("content_and_footer")[0].scrollTo(0, 0);

    const get_blog_posts = async ()=>{
      setIsLoading(true);
      setLoadingBarProgress.current(30);
      let http_resp = await fetch("/get_blog_posts", {method: "POST", body: JSON.stringify({"post_per_page": post_per_page, "start": 0})});
      http_resp = JSON.parse(await http_resp.text());
      setLoadingBarProgress.current(70);
      setBlogsToShow(http_resp["posts"].map((ele_, idx_)=>{
        return <BlogCard title={ele_["title"]} publish_date={ele_["publish_date"]} content={ele_["description"].trim()} blog_id={ele_["_id"]} key={"blog_card_asa"+idx_} />
      }));
      setIsLoading(false);
      setLoadingBarProgress.current(100);
    }
    get_blog_posts();
  }, []);

  return (
    <div className='blog_page_body'>
        <div className='per_page_heading blog_heading_heading'>
          <span className='back'>Blog</span>
          <span className='front'>Blog</span>
        </div>
        <hr style={{width: "100%", border: "1px solid gray", opacity: "0.3"}}/>
        <div className='blog_content'>
          {isLoading ? 
          <span style={{marginLeft: "auto", marginRight: "auto"}}>
            <LoadingCircle width={30} height={30} />
          </span>
          :
          blogsToShow
          }
          {/* <BlogCard title={"My Blog"} publish_date={"April 25, 2025"} content={"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptates fugit, debitis deserunt perferendis ducimus provident. Soluta mollitia adipisci corporis quidem cum itaque eveniet delectus alias architecto, facilis numquam a dolores?"} />
          <BlogCard title={"My Blog"} publish_date={"April 25, 2025"} content={"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptates fugit, debitis deserunt perferendis ducimus provident. Soluta mollitia adipisci corporis quidem cum itaque eveniet delectus alias architecto, facilis numquam a dolores?"} />
          <BlogCard title={"My Blog"} publish_date={"April 25, 2025"} content={"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptates fugit, debitis deserunt perferendis ducimus provident. Soluta mollitia adipisci corporis quidem cum itaque eveniet delectus alias architecto, facilis numquam a dolores?"} />
          <BlogCard title={"My Blog"} publish_date={"April 25, 2025"} content={"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptates fugit, debitis deserunt perferendis ducimus provident. Soluta mollitia adipisci corporis quidem cum itaque eveniet delectus alias architecto, facilis numquam a dolores?"} />
          <BlogCard title={"My Blog"} publish_date={"April 25, 2025"} content={"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptates fugit, debitis deserunt perferendis ducimus provident. Soluta mollitia adipisci corporis quidem cum itaque eveniet delectus alias architecto, facilis numquam a dolores?"} /> */}
        </div>
    </div>
  )
}
